import Vue from "vue";
import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    loading: false,
  },
  getters: {
    loading: (state) => state.loading,
  },
  actions: {
    async createContent({ commit, dispatch }, model) {
      return ajax
        .post("CMS/api/Content", model)
        .then((r) => r)
        .catch((e) => console.log(e));
    },
    async deleteContent({ commit, dispatch }, model) {
      return ajax
        .delete(
          "CMS/api/Content",
          { data: model },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((r) => r)
        .catch((e) => console.log(e));
    },
    async editContent({ commit, dispatch }, model) {
      return ajax
        .put("CMS/api/Content", model)
        .then((r) => r)
        .catch((e) => console.log(e));
    },
    async createContentItem({ commit, dispatch }, model) {
      return ajax
        .post("CMS/api/Content/addItems", model)
        .then((r) => r)
        .catch((e) => console.log(e));
    },
    async editContentItem({ commit, dispatch }, model) {
      return ajax
        .put("CMS/api/Content/Items", model)
        .then((r) => r)
        .catch((e) => console.log(e));
    },
    async deleteContentItem({ commit, dispatch }, model) {
      return ajax
        .delete(
          "CMS/api/Content/Items",
          { data: model },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((r) => r)
        .catch((e) => console.log(e));
    },
    async deleteContentItemAttachment({ commit, dispatch }, model) {
      return ajax
        .delete(
          "CMS/api/ContentImage",
          { data: model },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((r) => r)
        .catch((e) => console.log(e));
    },
    async postContentItemAttachment({ commit, dispatch }, model) {
      return ajax
        .post("CMS/api/ContentImage", model)
        .then((r) => r)
        .catch((e) => console.log(e));
    },
  },
  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },
  },
};
